import { Box, Typography } from "@mui/material";
import FormatService from "../../services/formatService";

interface CurrentValueProps {
  value: number;
}

const CurrentValue = ({ value }: CurrentValueProps) => {
  const { getMoneyFormat } = FormatService();

  return (
    <Box
      sx={{
        display: "flex",
        alignContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(65deg, #46bbff 0%, #1f40db 100%)",
          borderRadius: "10px",
          padding: { md: "15px", xs: "10px" },
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.25rem !important",
            color: "white",
            fontWeight: "700",
          }}
        >
          Current Value {getMoneyFormat(value)}
        </Typography>
      </Box>
    </Box>
  );
};

export default CurrentValue;
